<script>
import {mapState} from 'vuex';

export default {
    props: {
        name: {
            type: String,
            required: true
        },
        supplier: {
            type: String,
            required: true,
        },
        site: {
            type: String,
            required: true
        },
        updatedAt: {
            type: String,
            required: true
        },
        updatedBy: {
            type: String,
            required: true
        },
        siteId: {
            type: Number,
            required: true
        },
        accommodationSiteId: {
            type: Number,
            required: true
        }
    },
    data () {
        return {
            toggled: false
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
        })
    },
}
</script>
<template>
    <div :class="{'allocation-item__control--toggled': toggled}" class="allocation-item">
        <div class="allocation-item__header">
            <div class="allocation-item__label">
                {{ name }}
            </div>
            <div class="allocation-item__control" @click="toggled = !toggled">
                <i class="fa fa-fw fa-info"/>
            </div>
            <router-link :to="{name: 'manageAccommodationAllocation', params: { siteId, accommodationSiteId }}"
                         tag="div"
                         class="allocation-item__control">
                <i class="fa fa-fw fa-angle-right"/>
            </router-link>
        </div>
        <transition name="allocation-item__content-animation">
            <div v-if="toggled" class="allocation-item__content">
                <div class="allocation-item__props">
                    <div class="allocation-item__prop">
                        <div class="allocation-item__prop-key">
                            {{ $t('allocationItem.site') }}
                        </div>
                        <div class="allocation-item__prop-value">
                            {{ site }}
                        </div>
                    </div>
                    <div v-if="user.contractManager" class="allocation-item__prop">
                        <div class="allocation-item__prop-key">
                            {{ $t('allocationItem.supplier') }}
                        </div>
                        <div class="allocation-item__prop-value">
                            {{ supplier }}
                        </div>
                    </div>
                    <div class="allocation-item__prop">
                        <div class="allocation-item__prop-key">
                            {{ $t('allocationItem.updatedAt') }}
                        </div>
                        <div class="allocation-item__prop-value">
                            {{ updatedAt | moment("DD/MM/Y\, HH:mm") }}
                        </div>
                    </div>
                    <div class="allocation-item__prop">
                        <div class="allocation-item__prop-key">
                            {{ $t('allocationItem.updatedBy') }}
                        </div>
                        <div class="allocation-item__prop-value">
                            {{ updatedBy }}
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/AllocationItem/AllocationItem.vue